import { render, staticRenderFns } from "./TicketBlockMultipleCreate.vue?vue&type=template&id=0a7a8f90"
import script from "./TicketBlockMultipleCreate.vue?vue&type=script&lang=js"
export * from "./TicketBlockMultipleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports